import axios from 'axios';

const partnerPromise = axios
    .get(process.env.partnersUrl)
    .then(x => x.data)
    .then(x => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const pKey = urlSearchParams.get('p');
        if (!pKey) {
            return undefined;
        }
        return x.find(p => p.key === pKey)
    })
;

export function getPartner() {
    return partnerPromise;
}
